App.Map = {
    init:function() {

        App.Map.initMap('contact-map');
    }
    ,initMap : function (mapTarget) {

        if($('#contact-map').length){
            var style_array = [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]


            

            var mapOptions = {
                zoom: 12,
                center: new google.maps.LatLng(42.670138, 23.2377996),
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM,
                },
                minZoom:3,
                scrollwheel: false,
                panControl: false,
                streetViewControl: false,
                overviewMapControl: false,
                mapTypeControl: false,
                Marker: true, 
                styles : style_array,
                disableDefaultUI: true
            };

            var mapElement = document.getElementById(mapTarget);
            var map = new google.maps.Map(mapElement, mapOptions);
            
            App.Map.contact = map;


            App.Map.addPinsInit();
        }
    }

    ,addPinsInit : function(){

        var pinsCoordinates = $('#contact-map-pins').val();
        pinsCoordinates = jQuery.parseJSON(pinsCoordinates);
        App.Map.addPins(pinsCoordinates, App.Map.contact);
    }

    ,addPins : function(data, mapType){
        var bounds = new google.maps.LatLngBounds();
        var markersArr=[];

        $.each(data, function(key, data){

            var position = new google.maps.LatLng(data.lat, data.lng);
            var markers = new google.maps.Marker({
                map: mapType,
                position: position,
                icon: {
                    url:  _root + 'images/home/map-pin.png',
                    scaledSize: { width: 48, height: 63},
                    anchor: { x: 24, y: 31 },
                },
                id: data.id,
                zIndex: 10

            });

            bounds.extend(markers.position);
            mapType.fitBounds(bounds);
        //    if(App.mobile){

        //    }

            var contentString = '<div class="content-marker"><p class="company-address">'+data.address+'</p><a target="_blank" href="https://maps.google.com?daddr='+data.lat+','+data.lng+'" class="company-detail-link"><span>View direction</span></a></div>';

            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            markers.addListener("click", function (e){
                infowindow.open(mapType, markers);
            });
            
            
            markersArr.push(markers);
        });
        // var markerCluster = new MarkerClusterer(mapType, markersArr, App.Map.getClusterOptions());
       
        class CustomRenderer extends markerClusterer.DefaultRenderer {
            render({ count, position }) {
              const div = document.createElement('div');
              div.className = 'custom-cluster-icon';
              div.innerText = count;
              div.style.backgroundImage = 'url(' + _root + 'images/home/map-pin-cluster.png)';
  
            return new google.maps.Marker({
                position,
                icon: {
                  url: div.style.backgroundImage.slice(4, -1).replace(/"/g, ""),
                  scaledSize: new google.maps.Size(48, 63),
                  labelOrigin: new google.maps.Point(25, 25)
                },
                label: {
                  text: count.toString(),
                  color: 'white',
                  fontSize: '16px',
                }
              });
            }
        }
        var map = mapType
        var markers = markersArr
        App.Map.cluster = new markerClusterer.MarkerClusterer({
            map, 
            markers,
            renderer: new CustomRenderer(),
        });

    }
    // Styles for cluster pins and label
    ,getClusterOptions : function() {
        return {
        sum_wrap : '<span class="sum-counter">',
        styles : [{
            url : _root + 'images/home/map-pin-cluster.png',
            width: 48,
            height: 79,
            anchor: [16, 0],
            textColor: '#fff',
            textSize: 14,
            iconAnchor: [0, 0],
        }]
        }

    }
}
